import React, { Component } from 'react';
import { useToggle, useAsync, } from 'react-use';
import { pick, sumBy, groupBy, keyBy, sortBy, omit, } from 'lodash';
import { Button } from 'reactstrap';
import Select from 'react-select';
import qs from 'qs';
import { format as formatDate, startOfMonth, endOfMonth, } from 'date-fns';

import firebase, { functions } from '../../firebase';
import { numberFormat } from '../../util';
import { startOfMonthByFiscalYears, fiscalYearOfPeriod, fullPathWithParams } from '../../utils';
import { periodOfFiscalYear, } from '../../shared/util';
import { currencies, externalTypes, } from '../../shared/config';
import { canUpdateCompany } from '../../shared/abilities';
import { fieldsToEdit } from '../../shared/models/subsidiary';
import { pcaCompanyFields } from '../../shared/models/company';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useCompanySelector from '../hooks/useCompanySelector';
import useQueryParams from '../hooks/useQueryParams';
import RelatedCompanyPage from '../hocs/RelatedCompanyPage';
import ModelFormModal from '../modals/ModelFormModal';
import NonFreeeCompanyFormModal from '../modals/NonFreeeCompanyFormModal';
import CompanySyncButton from '../CompanySyncButton';
import TrialsSyncButton from '../TrialsSyncButton';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import QuerySelector from '../QuerySelector';

const getPcaDataAreas = functions.httpsCallable('getPcaDataAreas');

export default RelatedCompanyPage(function CompanyRelatedCompany (props) {
  const { relatedCompany, isParent, company, user, subsidiaryId, period, yearMonth, } = props;
  const { value: pcaDataAreas = [] } = useAsync(async () => {
    if(user.pca == null || relatedCompany.externalType !== 'pca') return [];

    const { data: { pcaDataAreas = [] } } = await getPcaDataAreas();
    return pcaDataAreas;
  }, [relatedCompany.externalType]);

  return props.translate(
    <div className="company-related-company">
      <div className="mb-3 d-flex justify-content-end gap-1">
        {user.pca && relatedCompany.externalType === 'pca' && (
          <EditButton
            label="データ領域(会計期間)"
            itemRef={relatedCompany.ref}
            item={(() => {
              const dataAreaIds = relatedCompany.fiscalYears?.map(_ => _.Name).filter(_ => _ != null) || [];
              return { dataAreaIds };
            })()}
            processValues={_ => {
              const pcaDataAreasByName = keyBy(pcaDataAreas, 'Name');
              return {
                fiscalYears: _.dataAreaIds.map(_ => pcaDataAreasByName[_]).map(_ => ({ ..._, start_date: [_.CompanyTermStart.slice(0, 4), _.CompanyTermStart.slice(4, 6), _.CompanyTermStart.slice(6)].join('-'), end_date: [_.CompanyTermEnd.slice(0, 4), _.CompanyTermEnd.slice(4, 6), _.CompanyTermEnd.slice(6)].join('-'), })),
              };
            }}
            FormModal={ModelFormModal}
            formProps={{ title: 'データ領域(会計期間) 編集', fields: pick(pcaCompanyFields({ dataAreas: pcaDataAreas, }), ['dataAreaIds']), }}
            disabled={!canUpdateCompany(company, user)}
          />
        )}
        <EditButton
          itemRef={relatedCompany.ref}
          processValues={_ => ({
            ..._,
            ...(_.fiscalYears && { fiscalYears: _.fiscalYears.map(_ => ({ ..._, start_date: formatDate(startOfMonth(_.start_date), 'yyyy-MM-dd'), end_date: formatDate(endOfMonth(_.end_date), 'yyyy-MM-dd'), })), }),
          })}
          FormModal={(relatedCompany.externalType == null || relatedCompany.externalType === 'bugyo') ? NonFreeeCompanyFormModal : ModelFormModal}
          formProps={{ title: '事業所 編集', fields: fieldsToEdit({ company, relatedCompany, }), }}
          disabled={!canUpdateCompany(company, user)}
        />
        {!isParent && <DeleteButton itemRef={relatedCompany.ref} disabled={!canUpdateCompany(company, user)} />}
      </div>
      <div>
        <table className="table table-bordered">
          <tbody className="thead-light">
            <tr>
              <th style={{ width: 200 }}>事業所名</th>
              <td>
                {relatedCompany.display_name}
                {relatedCompany.externalType != null && <span className="badge badge-info ml-1">{externalTypes[relatedCompany.externalType]?.label}連携</span>}
              </td>
            </tr>
            <tr>
              <th style={{ width: 200 }}>通貨</th>
              <td>
                {currencies[relatedCompany.currency || 'jpy'].label}
              </td>
            </tr>
            {
              relatedCompany.joinPeriod != null && (
                <tr>
                  <th style={{ width: 200 }}>連結対象になった年月</th>
                  <td>
                    {relatedCompany.joinYearMonth}
                    {relatedCompany.isStartJoin && <span className="ml-1 badge badge-info">月初</span>}
                  </td>
                </tr>
              )
            }
            {
              relatedCompany.exceptPeriod != null && (
                <tr>
                  <th style={{ width: 200 }}>連結除外になった年月</th>
                  <td>
                    {relatedCompany.exceptYearMonth}
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </div>
  );
});
